import { render, staticRenderFns } from "./bankSetMexico.vue?vue&type=template&id=1cec0b56&scoped=true"
import script from "./bankSetMexico.vue?vue&type=script&lang=js"
export * from "./bankSetMexico.vue?vue&type=script&lang=js"
import style0 from "./bankSetMexico.vue?vue&type=style&index=0&id=1cec0b56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec0b56",
  null
  
)

export default component.exports